import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import DashboardLayout from "../layouts/DashboardLayout";
import DashboardLibrary from "./dashboard/DashboardLibrary";
import DashboardCreate from "./dashboard/DashboardCreate";
import AudioDocumentDetail from "./dashboard/AudioDocumentDetail";
import DashboardSettings from "./dashboard/DashboardSettings";
import DashboardBilling from "./dashboard/DashboardBilling";
import DashboardSupport from "./dashboard/DashboardSupport";

const Dashboard = () => {
    return (
        <Routes>
            <Route element={<DashboardLayout />}>
                <Route
                    index
                    element={<Navigate to="/dashboard/create" replace />}
                />
                <Route path="library" element={<DashboardLibrary />} />
                <Route path="library/:id" element={<AudioDocumentDetail />} />
                <Route path="create" element={<DashboardCreate />} />
                <Route path="pricing" element={<DashboardBilling />} />
                <Route path="settings" element={<DashboardSettings />} />
                <Route path="support" element={<DashboardSupport />} />
                <Route
                    path="*"
                    element={<Navigate to="/dashboard/library" replace />}
                />
            </Route>
        </Routes>
    );
};

export default Dashboard;
